import React, { useState, useEffect } from 'react';
import { useCookies } from "react-cookie";
import { Link, useNavigate, useLocation } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { ActivePlan } from '../api/Service';
import './css.css'



const SideBar = () => {
  const PlanTypeName = localStorage.getItem('PlanTypeName');
  const [cookies, setCookie, removeCookie] = useCookies(['https://accounts.google.com']);
  const [loading, setLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false); // For toggling sidebar visibility
  const navigate = useNavigate();
  const location = useLocation();
  const [active, setActive] = useState(PlanTypeName);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const userId = localStorage.getItem('userid')
  const firstName = localStorage.getItem('firstName')
  const lastName = localStorage.getItem('lastName')
  const Email = localStorage.getItem('email')

  const ActiveApi = async () => {
    const res = await ActivePlan();
    //localStorage.setItem('Subscription', res.data.data.subscriptionStatus);
    // localStorage.setItem('PlanTypeName', res.data.data.PlanTypeName);
    setActive(res.data.data.PlanTypeName);
  };

  useEffect(() => {
    ActiveApi();
    setLoading(false);
  }, []);



  const email = localStorage.getItem('email');
  useEffect(() => {
    if (location.pathname === '/app/opt-email' || location.pathname === '/app/opt-mail') {
      setDropdownVisible(true);
    } else {
      setDropdownVisible(false);
    }
  }, [location.pathname]);
  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };
  const handleClearStorage = () => {
    setLoading(true);
    localStorage.clear();
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('Token');
    sessionStorage.clear();
    for (const cookieName in cookies) {
      removeCookie(cookieName);
    }
    setLoading(false)
    navigate('/app/login');
    window.location.reload(false);
  };

  const priority = () => {
    navigate('/app/subscription');
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  useEffect(() => {
    window.$fvIdentity = {
      id: userId,                     // Required - string - unique user identifier
      name: firstName,                 // Required - string - user's name
      email: Email,           // Optional - string - user's email
      disableReplaysForUser: false,      // Optional - boolean - disables replays for the user
      env: '',                   // Optional - string - used for segmentation and environment-based settings
      customField: '',   // Optional - [key: string]: primitive - used do add custom fields with custom data
    };
  }, [])

  return (
    <div className="flex h-full bg-[#121212] text-white">
      {/* Burger Menu Button for Mobile */}
      <div className="possition md:hidden p-4">
        <button onClick={toggleSidebar} className="text-white">
          {sidebarOpen ? <CloseIcon className='text-white' /> : <MenuIcon />}
        </button>
      </div>

      {/* Sidebar */}
      <div
        className={`w-[250px] bg-[#1E1E1E] p-6 flex flex-col transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'
          } md:translate-x-0 transition-transform duration-300 ease-in-out fixed md:relative h-full z-50`}
      >
        <div className=" flex justify-end md:hidden">
          <button onClick={toggleSidebar} className=" text-white">
            <ArrowBackIcon />
          </button>
        </div>
        <h1 className=" text-xl font-bold mb-8">AI Credit Repair</h1>

        <ul className="space-y-4 flex-grow">
          {/* <li
            className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/dashboard" ? "bg-[#651FFF]" : ""
              }`}
            onClick={() => handleNavigation('/app/dashboard')}
          >
            <HomeIcon className="mr-2" />
            <Link className="nav-link" to="/app/dashboard">
              Dashboard
            </Link>
          </li> */}
          {/* <a
            href='https://aicreditrepair.io/courses/fixing-your-credit-with-ai-credit-repair/lesson/should-you-pay-off-collections-expert-advice-on-debt-and-credit/'
            target="_blank"
            rel="noopener noreferrer"
          >
            <li
              className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer mt-2 ${location.pathname === "" ? "bg-[#651FFF]" : ""
                }`}
            >
              <LocalLibraryIcon className="mr-2" />
              <span className="nav-link">
                Learning Center
              </span>
            </li>
          </a> */}
          <li
            className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/utilization" ? "bg-[#651FFF]" : ""
              }`}
            onClick={() => handleNavigation('/app/utilization')}
          >
            <AutoGraphIcon className='mr-2' />
            <Link className="nav-link" to="/app/utilization">
              AI Credit Card Utilization
            </Link>
          </li>
          <li
            className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/credit-coach" ? "bg-[#651FFF]" : ""
              }`}
            onClick={() => handleNavigation('/app/credit-coach')}
          >
            <QuestionAnswerIcon className='mr-2' />
            <Link className="nav-link" to="/app/credit-coach">
              AI Credit Coach
            </Link>
          </li>
          {active === 'Starter Plan' || active === 'Free' ? (
            <li
              className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/remove-collections" ? "bg-[#651FFF]" : ""
                }`}
              onClick={() => handleNavigation('/app/remove-collections')}
            >
              <AdminPanelSettingsIcon className='mr-2' />
              <Link className="nav-link" to="/app/remove-collections">
                AI Dispute Letter
              </Link>
              {/* <LockIcon className='mr-2' /> */}
            </li>
          ) : (
            <li
              className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/remove-collections" ? "bg-[#651FFF]" : ""
                }`}
              onClick={() => handleNavigation('/app/remove-collections')}
            >
              <AdminPanelSettingsIcon className='mr-2' />
              <Link className="nav-link" to="/app/remove-collections">
                AI Dispute Letter
              </Link>
            </li>
          )}
          {active === 'Free' ? (
            <li
              className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/remove-public-records" ? "bg-[#651FFF]" : ""
                }`}
              onClick={() => handleNavigation('/app/remove-public-records')}
            >
              <TextSnippetIcon className='mr-2' />
              <span className="nav-link">
                Remove Public <span style={{ display: 'block' }}>Legal Data</span>
              </span>
            </li>
          ) : (
            <li
              className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/remove-public-records" ? "bg-[#651FFF]" : ""
                }`}
              onClick={() => handleNavigation('/app/remove-public-records')}
            >
              <TextSnippetIcon className='mr-2' />
              <span className="nav-link">
                Remove Public <span style={{ display: 'block' }}>Legal Data</span>
              </span>
            </li>
          )}


          <li className="flex flex-col items-start text-sm p-2 rounded cursor-pointer" onClick={toggleDropdown}>
            <div className="flex items-center">
              <TextSnippetIcon className="mr-2" />
              <span className="nav-link">
                AI Remove Public <span className="block">Property Data</span>
              </span>
            </div>

            {/* Conditionally render the dropdown menu */}
            {dropdownVisible && (
              <ul className="left-0 mt-1 w-48 rounded-lg shadow-lg z-10">
                <li
                  className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/opt-email" ? "bg-[#651FFF] text-white" : ""}`}
                  onClick={() => handleNavigation('/app/opt-email')}
                >
                  <TextSnippetIcon className="mr-2" />
                  Opt Out by Email
                </li>
                <li
                  className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/opt-mail" ? "bg-[#651FFF] text-white" : ""}`}
                  onClick={() => handleNavigation('/app/opt-mail')}
                >
                  <TextSnippetIcon className="mr-2" />
                  Opt Out by Mail
                </li>
              </ul>
            )}
          </li>


          {/* <li
                  className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/opt-email" ? "bg-[#651FFF]" : ""
                    }`}
                  onClick={() => handleNavigation('/app/opt-email')}
                >
                  <TextSnippetIcon className='mr-2' />
                  Opt Out by Email
                </li>
                <li
                  className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/opt-mail" ? "bg-[#651FFF]" : ""
                    }`}
                  onClick={() => handleNavigation('/app/opt-mail')}
                >
                  <TextSnippetIcon className='mr-2' />
                  Opt Out by Mail
                </li> */}
<li
            className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer`}
            onClick={() => handleNavigation('/app/score-simulator')}
          >
            <AutoAwesomeIcon className='mr-2' />
            <Link className="nav-link" to="/app/score-simulator">
              Ai Score Simulator
            </Link>
            {/* <LockIcon className='ml-12' /> */}
          </li>
          {/* <li
            className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer`}
            onClick={() => handleNavigation('/app/mail')}
          >
            <NotificationsIcon className='mr-2' />
            <Link className="nav-link" to="/app/mail">
              Send Direct Mail
            </Link>
          
          </li> */}

          <li
            className={`flex items-center text-sm p-2 rounded hover:bg-[#651FFF] cursor-pointer ${location.pathname === "/app/subscription" ? "bg-[#651FFF]" : ""
              }`}
            onClick={() => handleNavigation('/app/subscription')}
          >
            <SettingsIcon className='mr-2' />
            <Link className="nav-link" to="/app/subscription">
              Lifetime Access
            </Link>
          </li>
          <li className="flex items-center text-sm p-2 rounded hover:bg-red-600 cursor-pointer">
            <button className="" onClick={handleClearStorage}>
              <LogoutIcon className='mr-2 ml-1' />
              Logout
            </button>
          </li>
          {/* <div className="">
            <div className="p-4 bg-[#4527A0] rounded-lg text-center text-sm cursor-pointer" onClick={priority}>
              <p>Upgrade</p>
              <p className="font-bold text-lg">PRIORITY</p>
              <i className="fas fa-arrow-right"></i>
            </div>
          </div> */}
        </ul>

      </div>

      {/* Loading Spinner */}
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-opacity-50 bg-white">
          <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-[#651FFF]" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SideBar